<div class="notifications-container">
    <div class="header-container">
        <div class="dx-field-label">Afiseaza toate notificarile</div>
        <dx-switch [(value)]="seeNew" hint="Vezi toate notificarile"></dx-switch>
    </div>
    <ibis-notify [newOnly]="!seeNew"></ibis-notify>
</div>
